/** 全局串行图片加载队列：同一时间只加载 1 张图片 */
const MAX_CONCURRENT = 1;
let active = 0;
const pending: Array<() => void> = [];

function drain(): void {
  while (active < MAX_CONCURRENT && pending.length > 0) {
    const next = pending.shift();
    if (next) next();
  }
}

export function enqueueImageLoad<T>(task: () => Promise<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    const run = () => {
      active += 1;
      task()
        .then(resolve, reject)
        .finally(() => {
          active -= 1;
          drain();
        });
    };
    if (active < MAX_CONCURRENT) run();
    else pending.push(run);
  });
}

export function preloadImage(src: string): Promise<void> {
  return enqueueImageLoad(
    () =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = () => reject(new Error(`Failed to load ${src}`));
        img.src = src;
      })
  );
}

/** 返回当前队列中等待的任务数量 */
export function pendingImageCount(): number {
  return pending.length;
}
